// Define showMeerkat stub immediately to prevent "not found" errors
window.showMeerkat = function() {
  console.log('Marketing modal is still loading, please wait...');
};

(async function() {
  try {
  const css = `
  .meerkat-modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(4, 4, 6, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

/* Modal Content/Box */
.meerkat-modal-content {
  background: #101012;
  background-image: radial-gradient(circle at 0% 0%, rgba(227, 252, 2, 0.06), transparent 55%);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 14px;
  width: 100%;
  max-width: 760px;
  display: flex;
  align-items: stretch;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55);
  position: relative;
  opacity: 0;
  transform: translateY(14px) scale(0.97);
  transition: opacity 0.45s cubic-bezier(0.16, 1, 0.3, 1), transform 0.45s cubic-bezier(0.16, 1, 0.3, 1);
}

.meerkat-modal.meerkat-in .meerkat-modal-content {
  opacity: 1;
  transform: none;
}

.meerkat-wrapper {
  flex: 1;
  min-width: 0;
  display: flex;
}

.meerkat-modal-text {
  padding: 36px 36px 28px;
  flex: 1;
  min-width: 0;
}

/* The Close Button */
.meerkat-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 3;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(16, 16, 18, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.meerkat-close:hover,
.meerkat-close:focus {
  background: #e3fc02;
  border-color: #e3fc02;
  color: #111114;
}

/* Car image panel (right side on desktop, top banner on mobile) */
/* Extra specificity: the theme's base.css hides empty divs via div:empty */
.meerkat-modal-content .meerkat-modal-img {
  display: block;
  flex: 0 0 42%;
  order: 2;
  background-size: cover;
  background-position: center center;
  position: relative;
  min-height: 400px;
}

.meerkat-modal-img::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(270deg, rgba(16, 16, 18, 0) 55%, rgba(16, 16, 18, 0.92) 100%),
    linear-gradient(0deg, rgba(16, 16, 18, 0.35), rgba(16, 16, 18, 0) 40%);
  pointer-events: none;
}

/* Typography */
.meerkat-eyebrow {
  color: #e3fc02;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  margin: 0 0 12px;
}

.meerkat-display {
  color: #f5f5f2;
  font-size: clamp(42px, 5.5vw, 60px);
  font-weight: 900;
  font-style: italic;
  line-height: 1;
  letter-spacing: -0.02em;
  text-transform: uppercase;
  margin: 0;
}

.meerkat-heading {
  color: #f5f5f2;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  margin: 0;
}

.meerkat-qual {
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin: 12px 0 0;
}

.meerkat-sub {
  color: rgba(255, 255, 255, 0.68);
  font-size: 14px;
  line-height: 1.55;
  margin: 14px 0 0;
}

.meerkat-modal-text a {
  color: #e3fc02;
}

/* Discount decay strip: makes the dwindling deal scannable */
.meerkat-decay {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 18px;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
}

.meerkat-decay-step {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.meerkat-decay-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}

.meerkat-decay-amt {
  font-size: 18px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.55);
}

.meerkat-decay-now .meerkat-decay-amt {
  color: #e3fc02;
}

.meerkat-decay-arrow {
  color: rgba(255, 255, 255, 0.35);
  font-size: 16px;
}

.meerkat-countdown {
  margin: 14px 0 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}

.meerkat-countdown span {
  color: #e3fc02;
  letter-spacing: 0.08em;
  font-variant-numeric: tabular-nums;
}

/* Form */
.meerkat-field-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.55);
  margin: 20px 0 6px;
}

.meerkat-input {
  width: 100%;
  box-sizing: border-box;
  background: #18181b;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  color: #f5f5f2;
  padding: 12px 14px;
  font-size: 15px;
  font-family: inherit;
  display: block;
  user-select: text !important;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.meerkat-input:focus {
  outline: none;
  border-color: #e3fc02;
  box-shadow: 0 0 0 3px rgba(227, 252, 2, 0.15);
}

.meerkat-input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.meerkat-input::selection {
  background-color: rgba(227, 252, 2, 0.3);
}

.meerkat-input-error {
  border-color: #ff5252 !important;
}

.meerkat-error-text {
  display: none;
  color: #ff7a7a;
  font-size: 12px;
  margin: 6px 0 0;
}

.meerkat-error-text.meerkat-visible {
  display: block;
}

.meerkat-button {
  width: 100%;
  margin-top: 14px;
  background: #e3fc02;
  color: #111114;
  border: none;
  border-radius: 8px;
  padding: 14px 18px;
  font-size: 15px;
  font-weight: 800;
  font-family: inherit;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  transition: transform 0.15s ease, filter 0.2s ease;
}

.meerkat-button:hover {
  filter: brightness(1.08);
  transform: translateY(-1px);
}

.meerkat-button:active {
  transform: scale(0.98);
}

.meerkat-nothanks {
  margin: 14px 0 0;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: color 0.2s;
}

.meerkat-nothanks:hover {
  color: rgba(255, 255, 255, 0.75);
}

/* Discount code chip (phone step) */
.meerkat-code-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 16px 0 4px;
  padding: 12px 12px 12px 16px;
  border: 1px dashed rgba(227, 252, 2, 0.5);
  border-radius: 8px;
  background: rgba(227, 252, 2, 0.06);
  cursor: pointer;
}

.meerkat-code-value {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0.22em;
  color: #e3fc02;
}

.meerkat-copy {
  flex: 0 0 auto;
  background: transparent;
  border: 1px solid rgba(227, 252, 2, 0.5);
  border-radius: 6px;
  color: #e3fc02;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  padding: 7px 12px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.meerkat-code-chip:hover .meerkat-copy,
.meerkat-copy:hover {
  background: #e3fc02;
  color: #111114;
}

.meerkat-divider {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.09);
  margin: 22px 0 0;
}

/* Floating reopen button (display: block overrides base.css div:empty rule) */
#MeerkatOpen {
   display: block;
   width: 93px;
   height: 93px;
   background: url(https://www.auravinyl.com/cdn/shop/t/3/assets/discount-icon.png);
   background-size: cover;
   position: fixed;
   bottom: 100px;
   right: 30px;
   cursor: pointer;
   z-index: 99;
   transition: transform 0.2s ease;
}

#MeerkatOpen:hover {
   transform: scale(1.06);
}

@keyframes meerkat-pop {
   0% { transform: scale(0.3); opacity: 0; }
   60% { transform: scale(1.08); }
   100% { transform: scale(1); opacity: 1; }
}

#MeerkatOpen.meerkat-pop {
   animation: meerkat-pop 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@media (prefers-reduced-motion: reduce) {
  .meerkat-modal-content {
    transition: none;
    opacity: 1;
    transform: none;
  }
  #MeerkatOpen.meerkat-pop {
    animation: none;
  }
}

/* Responsive styling */
@media screen and (max-width: 600px) {
  .meerkat-modal {
    padding: 10px;
    align-items: center;
  }
  .meerkat-modal-content {
    flex-direction: column;
    max-height: calc(100dvh - 20px);
    overflow-y: auto;
    border-radius: 12px;
  }
  /* Banner is a portrait photo with the car in the lower third — anchor there */
  .meerkat-modal-content .meerkat-modal-img {
    flex: 0 0 auto;
    order: 0;
    height: 140px;
    min-height: 0;
    background-size: cover;
    background-position: 68% 78%;
  }
  .meerkat-modal-img::after {
    background: linear-gradient(180deg, rgba(16, 16, 18, 0) 60%, rgba(16, 16, 18, 0.7) 100%);
  }
  .meerkat-modal-text {
    padding: 12px 16px 14px;
  }
  .meerkat-eyebrow {
    font-size: 11px;
    letter-spacing: 0.14em;
    margin: 0 0 6px;
  }
  .meerkat-display {
    font-size: 32px;
  }
  .meerkat-qual {
    font-size: 11px;
    letter-spacing: 0.1em;
    margin: 6px 0 0;
  }
  .meerkat-sub {
    font-size: 13px;
    line-height: 1.4;
    margin: 8px 0 0;
  }
  .meerkat-decay {
    margin-top: 10px;
    padding: 8px 12px;
    gap: 10px;
  }
  .meerkat-decay-amt {
    font-size: 15px;
  }
  .meerkat-countdown {
    margin: 8px 0 0;
    font-size: 10px;
  }
  .meerkat-field-label {
    margin: 10px 0 5px;
  }
  .meerkat-input {
    padding: 10px 12px;
    font-size: 16px; /* keep 16px to avoid iOS zoom */
  }
  .meerkat-button {
    margin-top: 10px;
    padding: 12px 14px;
    font-size: 14px;
  }
  .meerkat-nothanks {
    margin: 10px 0 0;
  }
  .meerkat-heading {
    font-size: 22px;
  }
  .meerkat-code-chip {
    margin: 10px 0 4px;
    padding: 10px;
  }
  .meerkat-code-value {
    font-size: 20px;
  }
  .meerkat-divider {
    margin: 14px 0 0;
  }

  #MeerkatOpen {
     width: 60px;
     height: 60px;
     bottom: 90px;
     right: 20px;
  }
}
  `;

// Fetch holiday list with error handling
let holidays = [];
try {
  const holidayRequest = await fetch('https://marketing.auravinyl.com/hollist');
  const holidayJSON = await holidayRequest.json();
  holidays = holidayJSON.list;
} catch (error) {
  console.warn('Failed to load holiday list, using defaults:', error);
  holidays = [];
}
const DISCOUNT_DAYS = 3;

function isTodayBetweenDates(start, end) {
  // Create date objects for the start and end dates within the current year
  const year = new Date().getFullYear();
  const startDate = new Date(`${start}, ${year}`);
  const endDate = new Date(`${end}, ${year}`);
  
  // Get today's date
  const today = new Date();
  
  // Set the time of today, start, and end dates to 00:00:00 for accurate comparison
  today.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  
  // Check if today is between the start and end dates (inclusive)
  return today >= startDate && today <= endDate;
}

let cachedSpecial;
function getSpecial() {
  if (cachedSpecial) return cachedSpecial;
  for (let i = 0; i < holidays.length; i++) {
      let holiday = holidays[i];
      if (isTodayBetweenDates(holiday.start, holiday.end)) {
        cachedSpecial = holiday;
      }
  }

  return cachedSpecial;
}

function getMonth() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  
  // Get the last day of the current month
  const lastDayOfMonth = new Date(year, month + 1, 0).getDate();

  // Check if the current date is less than a week away from the next month
  if (day > lastDayOfMonth - DISCOUNT_DAYS) {
    // If yes, increment the month by one, adjusting for year wrap
    const nextMonth = new Date(year, month + 1, 1);
    return monthName(nextMonth.getMonth());
  } else {
    // If no, just return the current month name
    return monthName(month);
  }
}

function monthName(monthIndex) {
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  return monthNames[monthIndex];
}

function getFrom() {
    let special = getSpecial();
    if (special) return special.start;

    let storage = localStorage.getItem('startDate');
    if (storage) return storage;
    const now = new Date();
    let month = monthName(now.getMonth());
    const day = now.getDate();
    let val = `${month} ${day}`;  // Ensures 2-digit day
    localStorage.setItem('startDate', val);
    return val;
}

function getTo() {
    let special = getSpecial();
    if (special) {
      return special.end;
    }
  
    let storage = localStorage.getItem('futureDate');
    if (storage) return storage;
    const now = new Date();
    const futureDate = new Date(now);
    futureDate.setDate(now.getDate() + DISCOUNT_DAYS);

    const month = monthName(futureDate.getMonth());
    const day = futureDate.getDate();

    let val = `${month} ${day}`;  // Ensures 2-digit day
    localStorage.setItem('futureDate', val);
    return val;
}

// Assuming the stored date is in the format "MMM DD" as returned by getTo()
function hasStoredDatePassed() {
  const storedDateString = localStorage.getItem('futureDate'); // Retrieve the date string from localStorage
  if (!storedDateString) {
    // console.log('No date stored in localStorage');
    return false;
  }

  const currentYear = new Date().getFullYear();
  const storedDate = new Date(`${storedDateString} ${currentYear}`);

  // Check if the stored date year needs to be incremented (case for end of year)
  if (new Date() > storedDate && new Date().getMonth() === 11 && storedDate.getMonth() === 0) {
    storedDate.setFullYear(storedDate.getFullYear() + 1);
  }

  const now = new Date();
  return now > storedDate; // Returns true if the stored date has passed
}

function isTodayInStoredRange() {
  const from = localStorage.getItem('startDate');
  const to = localStorage.getItem('futureDate');
  if (!from || !to) return true;
  return isTodayBetweenDates(from, to);
}

function readyDates() {
  if (hasStoredDatePassed() || getSpecial() || !isTodayInStoredRange()) {
    localStorage.removeItem('futureDate');
    localStorage.removeItem('startDate');
  }
}

function getSale() {
  let special = getSpecial();
  if (special) {
    return getEmoji() + ' ' + special.name + ' Sale';
  }
  
  return `${getEmoji()} ${getMonth().toUpperCase()} Special`;
}

function getEmoji() {
  let special = getSpecial();
  if (special) {
    return special.emoji;
  }
  
  return '🚀';
}

function getDiscountOff() {
  let special = getSpecial();
  if (special) {
    if (special.amountOff) return special.amountOff;
  }
  
  return 50;
}

function getDiscountCode() {
  let special = getSpecial();
  if (special) {
    if (special.code) return special.code;
  }
  
  return 'HSKHJM';
}

function getShippingNotice() {
  let special = getSpecial();
  if (special && special.shippingNotice) {
    return '<p class="meerkat-sub">This sale has a <a href="https://www.auravinyl.com/pages/shipping-notification">SHIPPING NOTICE</a></p>';
  }
  return '';
}

readyDates();

// End-of-day deadline for the countdown, based on the same date the copy uses
function getEndDate() {
  const year = new Date().getFullYear();
  let end = new Date(`${getTo()}, ${year} 23:59:59`);
  const now = new Date();
  if (end < now && now.getMonth() === 11 && end.getMonth() === 0) {
    end.setFullYear(end.getFullYear() + 1);
  }
  return end;
}

function isLastDayOfSale() {
  const now = new Date();
  return `${monthName(now.getMonth())} ${now.getDate()}` === getTo();
}

const isTodayOnly = isLastDayOfSale();

const subLine = isTodayOnly
  ? 'Today only. When it\'s gone, it\'s gone.'
  : 'The deal dwindles daily. The sooner you act, the more you save.';

const decayHtml = function() {
  const off = getDiscountOff();
  if (isTodayOnly) {
    return `<div class="meerkat-decay">
      <div class="meerkat-decay-step meerkat-decay-now">
        <span class="meerkat-decay-label">Today only</span>
        <span class="meerkat-decay-amt">$${off} off</span>
      </div>
    </div>`;
  }
  return `<div class="meerkat-decay">
    <div class="meerkat-decay-step meerkat-decay-now">
      <span class="meerkat-decay-label">Order today</span>
      <span class="meerkat-decay-amt">$${off} off</span>
    </div>
    <div class="meerkat-decay-arrow">&rarr;</div>
    <div class="meerkat-decay-step">
      <span class="meerkat-decay-label">${getTo()}</span>
      <span class="meerkat-decay-amt">$${Math.round(off * 0.5)} off</span>
    </div>
  </div>`;
};

const codeSubLine = isTodayOnly
  ? `Use it at checkout for $${getDiscountOff()} off a full roll. Today only.`
  : `Use it at checkout for $${getDiscountOff()} off a full roll. On ${getTo()} it drops to $${Math.round(getDiscountOff() * 0.5)}.`;

const html = `
<div id="myModal" class="meerkat-modal" style="display: none;">

  <!-- Modal content -->
  <div class="meerkat-modal-content">
    <div class="meerkat-modal-img" role="img" aria-label="Black Audi TTRS wrapped in Aura vinyl"></div>
    <span class="meerkat-close">&times;</span>

    <div id="meerkat-email-entry" class="meerkat-wrapper">
        <div class="meerkat-modal-text">
        <p class="meerkat-eyebrow">${getSale()}</p>
        <h2 class="meerkat-display">$${getDiscountOff()} OFF</h2>
        <p class="meerkat-qual">When you order a full roll</p>
        <p class="meerkat-sub">${subLine}</p>
        ${decayHtml()}
        <p class="meerkat-countdown">Ends in <span id="meerkat-timer"></span></p>
        ${getShippingNotice()}
        <label class="meerkat-field-label" for="email-input">Email address</label>
        <input class="meerkat-input" id="email-input" type="email" placeholder="you@email.com" autocomplete="email" inputmode="email">
        <p class="meerkat-error-text" id="email-error">Please enter a valid email address.</p>
        <button id="submit-email" class="meerkat-button">Get my $${getDiscountOff()} code</button>
        <p class="meerkat-nothanks">No thanks</p>
        </div>
    </div>

    <div id="meerkat-phone-entry" class="meerkat-wrapper" style="display: none;">
        <div class="meerkat-modal-text">
        <p class="meerkat-eyebrow">You're in</p>
        <h2 class="meerkat-heading">Your discount code</h2>
        <div class="meerkat-code-chip" id="meerkat-code-chip" title="Click to copy">
          <span class="meerkat-code-value" id="meerkat-code-value">${getDiscountCode()}</span>
          <button class="meerkat-copy" id="meerkat-copy">COPY</button>
        </div>
        <p class="meerkat-sub">${codeSubLine}</p>
        <p class="meerkat-sub">Partial roll? Use code <b>YZWHGV</b> for 10% off.</p>
        ${getShippingNotice()}
        <hr class="meerkat-divider" />
        <label class="meerkat-field-label" for="phone-input">Get exclusive offers by text</label>
        <input class="meerkat-input" id="phone-input" type="tel" placeholder="Phone number" autocomplete="tel" inputmode="tel">
        <p class="meerkat-error-text" id="phone-error">Please enter a valid phone number.</p>
        <button id="submit-phone" class="meerkat-button">Text me offers</button>
        <p class="meerkat-nothanks">No thanks</p>
        </div>
    </div>

    <div id="meerkat-thanks" class="meerkat-wrapper" style="display: none;">
        <div class="meerkat-modal-text">
        <p class="meerkat-eyebrow">You're all set</p>
        <h2 class="meerkat-heading">Welcome to Aura</h2>
        <p class="meerkat-sub">If you own a shop, <a href="https://www.auravinyl.com/pages/shop-sign-up">sign up here</a> for wholesale pricing and marketing support.</p>
        <p class="meerkat-sub"><a href="https://discord.gg/xrHmQ53GhY" target="_blank">Join our Discord</a> to connect with us and thousands of community members.</p>
        <p class="meerkat-nothanks">Close</p>
        </div>
    </div>
  </div>
</div>
<div id="MeerkatOpen"></div>
`;

  // If user already has phone, don't show modal but still define empty function
  if (localStorage.getItem('mkt_phone')) {
    window.showMeerkat = function() {
      console.log('Marketing modal already completed');
    };
    window.hideAllMeerkat = function() {
      console.log('Marketing modal already completed');
    };
    return;
  }

  var style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
} else {
    style.appendChild(document.createTextNode(css));
}

// Append the style element to the head
document.head.appendChild(style);

    let state = 'email';
    let lastState;

  var newDiv = document.createElement('div');
  newDiv.innerHTML = html;
  document.body.appendChild(newDiv);

  // Side panel image: injected via header.liquid asset_url, falls back to the CDN copy
  const mascotUrl = window.MEERKAT_IMG || 'https://www.auravinyl.com/cdn/shop/t/3/assets/ttrs-market-banner.jpg';
  document.querySelectorAll('.meerkat-modal-img').forEach(el => {
    el.style.backgroundImage = `url("${mascotUrl}")`;
  });

  let closes = document.querySelectorAll('.meerkat-close');
  closes.forEach(close => close.onclick = closeClick);

  let nothanks = document.querySelectorAll('.meerkat-nothanks');
  nothanks.forEach(close => close.onclick = closeClick);

  let modal = document.querySelector('#myModal');
  modal.style.display = 'none';

  let openBtn = document.querySelector('#MeerkatOpen');
  openBtn.style.setProperty('display', 'none', 'important');

  let emailEntry = document.querySelector('#meerkat-email-entry');
  let phoneEntry = document.querySelector('#meerkat-phone-entry');
  let thanksPage = document.querySelector('#meerkat-thanks');

  // Icon visibility is forced inline so no third-party stylesheet can suppress it
  function showIcon(animate) {
    openBtn.style.setProperty('display', 'block', 'important');
    if (animate) {
      openBtn.classList.remove('meerkat-pop');
      void openBtn.offsetWidth; // restart the pop animation
      openBtn.classList.add('meerkat-pop');
    }
  }

  function hideIcon() {
    openBtn.style.setProperty('display', 'none', 'important');
  }

  // Center of the bottom-right spot where the re-open icon lives (mirrors the CSS)
  function iconCenter() {
    const mobile = window.matchMedia('(max-width: 600px)').matches;
    const size = mobile ? 60 : 93;
    const right = mobile ? 20 : 30;
    const bottom = mobile ? 90 : 100;
    return { x: window.innerWidth - right - size / 2, y: window.innerHeight - bottom - size / 2, w: size };
  }

  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cancelAnims() {
    const content = modal.querySelector('.meerkat-modal-content');
    if (content) content.getAnimations().forEach(a => a.cancel());
    modal.getAnimations().forEach(a => a.cancel());
  }

  function openModal() {
    state = lastState || state;
    cancelAnims();
    hideIcon();
    modal.style.display = 'flex';
    requestAnimationFrame(() => {
      modal.classList.add('meerkat-in');
      if (reduceMotion()) return;
      // Morph in from the icon's corner spot so the two feel connected
      const content = modal.querySelector('.meerkat-modal-content');
      const r = content.getBoundingClientRect();
      if (!r.width) return;
      const p = iconCenter();
      const scale = Math.max(0.1, p.w / r.width);
      const dx = p.x - (r.left + r.width / 2);
      const dy = p.y - (r.top + r.height / 2);
      content.animate(
        [{ transform: `translate(${dx}px, ${dy}px) scale(${scale})`, opacity: 0.4 },
         { transform: 'translate(0, 0) scale(1)', opacity: 1 }],
        { duration: 480, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );
    });
  }

  function closeClick() {
    lastState = state;
    state = 'closed';
    localStorage.setItem('mkt_hidden', true);
    // Drop blur immediately so the page isn't frosted during the close morph
    modal.style.backdropFilter = 'none';
    modal.style.webkitBackdropFilter = 'none';
    const content = modal.querySelector('.meerkat-modal-content');
    const r = content ? content.getBoundingClientRect() : { width: 0 };
    if (reduceMotion() || !r.width) {
      modal.classList.remove('meerkat-in');
      modal.style.display = 'none';
      modal.style.backdropFilter = '';
      modal.style.webkitBackdropFilter = '';
      showIcon(false);
      return;
    }
    // Morph the modal down into the icon's corner spot, then pop the icon in
    const p = iconCenter();
    const scale = Math.max(0.1, p.w / r.width);
    const dx = p.x - (r.left + r.width / 2);
    const dy = p.y - (r.top + r.height / 2);
    const anim = content.animate(
      [{ transform: 'translate(0, 0) scale(1)', opacity: 1 },
       { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, opacity: 0 }],
      { duration: 420, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' }
    );
    modal.animate(
      [{ backgroundColor: 'rgba(4, 4, 6, 0.72)' }, { backgroundColor: 'rgba(4, 4, 6, 0)' }],
      { duration: 380, easing: 'ease-out', fill: 'forwards' }
    );
    anim.onfinish = () => {
      modal.classList.remove('meerkat-in');
      modal.style.display = 'none';
      modal.style.backdropFilter = '';
      modal.style.webkitBackdropFilter = '';
      showIcon(true);
    };
  }

  openBtn.onclick = openModal;

  // Replace the stub with the actual function
  window.showMeerkat = _ => openBtn.onclick();
  window.hideAllMeerkat = _ => {
    cancelAnims();
    modal.classList.remove('meerkat-in');
    modal.style.display = 'none';
    hideIcon();
  };

  if (location.search.includes('showModal')) {
    openModal();
  } else {
    if (localStorage.getItem('mkt_hidden')) closeClick();
    else {
      setTimeout(openModal, 4000);
    }
  }

  function showFromState() {
    switch (state) {
      case 'email': 
        emailEntry.style.display = '';
        phoneEntry.style.display = 'none';
        thanksPage.style.display = 'none';
        break;

        case 'phone': 
        emailEntry.style.display = 'none';
        phoneEntry.style.display = '';
        thanksPage.style.display = 'none';
        break;

        case 'thanks': 
        emailEntry.style.display = 'none';
        phoneEntry.style.display = 'none';
        thanksPage.style.display = '';
        break;
    }
  }

  window.addEventListener('click', evt => {
    if (evt.target == modal) closeClick();
  });

  document.body.addEventListener('keyup', evt => {
    if (evt.key == 'Escape' && modal.style.display == 'flex') closeClick();
  });

  let emailInput = document.querySelector('#email-input');
  let phoneInput = document.querySelector('#phone-input');
  let emailError = document.querySelector('#email-error');
  let phoneError = document.querySelector('#phone-error');

  // Countdown timer, driven by the same end date as the sale copy
  let timerEl = document.querySelector('#meerkat-timer');
  function pad(n) { return n.toString().padStart(2, '0'); }
  function tickTimer() {
    if (!timerEl) return;
    let diff = getEndDate() - new Date();
    if (diff <= 0) {
      timerEl.textContent = 'LAST CHANCE';
      return;
    }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    timerEl.textContent = d >= 1 ? `${d}D ${pad(h)}H ${pad(m)}M` : `${pad(h)}:${pad(m)}:${pad(s)}`;
  }
  tickTimer();
  setInterval(tickTimer, 1000);

  // Click-to-copy discount code
  let codeChip = document.querySelector('#meerkat-code-chip');
  let codeValue = document.querySelector('#meerkat-code-value');
  let copyBtn = document.querySelector('#meerkat-copy');

  function fallbackCopy(text, done) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); done(); } catch (e) {}
    document.body.removeChild(ta);
  }

  codeChip.onclick = () => {
    const code = codeValue.textContent.trim();
    const done = () => {
      copyBtn.textContent = 'COPIED';
      setTimeout(() => copyBtn.textContent = 'COPY', 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(() => fallbackCopy(code, done));
    } else {
      fallbackCopy(code, done);
    }
  };

  async function postSignup(obj) {
     let id = localStorage.getItem('mkt');
     if (id) obj.id = id;
     let req = await fetch('https://marketing.auravinyl.com/events/user', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(obj)
     });
     let json = await req.json();
     localStorage.setItem('mkt', json.id);

     let array = localStorage.getItem('anon_mkt_list');
     if (array && array.startsWith('[')) {
       localStorage.removeItem('anon_mkt_list');
       array = JSON.parse(array);
       array.forEach(uri => {
         fetch('https://marketing.auravinyl.com/events/meerkat', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({id: json.id, uri})
        });
       });
     }
  }

  function fixEmailTypos(email) {
    const commonTypos = {
        'gmai.com': 'gmail.com',
        'gmail.comm': 'gmail.com',
        'gmial.com': 'gmail.com',
        'gmailcom': 'gmail.com',
        'gmal.com': 'gmail.com',
        'yahooo.com': 'yahoo.com',
        'yaho.com': 'yahoo.com',
        'yhoo.com': 'yahoo.com',
        'yahoo.comm': 'yahoo.com',
        'hotmial.com': 'hotmail.com',
        'hotmai.com': 'hotmail.com',
        'hotmal.com': 'hotmail.com',
        'homail.com': 'hotmail.com',
        'hotmail.comm': 'hotmail.com',
        'outllok.com': 'outlook.com',
        'outlook.comm': 'outlook.com',
        'otlook.com': 'outlook.com'
    };

      const emailParts = email.split('@');
      if (emailParts.length !== 2) {
          return email; // Invalid email format
      }
      
      const domain = emailParts[1].toLowerCase();
      if (commonTypos[domain]) {
          emailParts[1] = commonTypos[domain];
      }

    if (emailParts[1].includes('.comu')) emailParts[1] = emailParts[1].replace('.comu', 'com');
    if (emailParts[1].includes('.con')) emailParts[1] = emailParts[1].replace('.com', 'com');
    if (emailParts[1].includes('.comm')) emailParts[1] = emailParts[1].replace('.comm', 'com');
      
      return emailParts.join('@');
    }
  

  function submitEmail() {
    let text = emailInput.value;
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (emailRegex.test(text)) {
      emailInput.classList.remove('meerkat-input-error');
      emailError.classList.remove('meerkat-visible');
      postSignup({email: fixEmailTypos(text)});
      state = 'phone';
      showFromState();
      localStorage.setItem('mkt_hidden', true);
    } else {
      emailInput.value = '';
      emailInput.classList.add('meerkat-input-error');
      emailError.classList.add('meerkat-visible');
    }
  }

  function submitPhone() {
    let text = phoneInput.value;
    var phoneRegex = /^\+?(\d{1,3})?[-. ]?\(?\d{1,3}\)?[-. ]?\d{1,4}[-. ]?\d{1,4}[-. ]?\d{1,9}$/;
    let phoneRegex2 = /^\+?(\d{1,3})?[-. ]?(\(\d{3}\)|\d{3})[-. ]?\d{3}[-. ]?\d{4}$/;

    if (phoneRegex.test(text) || phoneRegex2.test(text)) {
      phoneInput.classList.remove('meerkat-input-error');
      phoneError.classList.remove('meerkat-visible');
      postSignup({phone: text});
      state = 'thanks';
      showFromState();
      localStorage.setItem('mkt_phone', true);
      openBtn.style.setProperty('display', 'none', 'important');
    } else {
      phoneInput.value = '';
      phoneInput.classList.add('meerkat-input-error');
      phoneError.classList.add('meerkat-visible');
    }
  }

  let emailSubmit = document.querySelector('#submit-email');
  emailSubmit.onclick = submitEmail;

  let phoneSubmit = document.querySelector('#submit-phone');
  phoneSubmit.onclick = submitPhone;

  document.body.addEventListener('keyup', evt => {
    if (evt.key == 'Enter') {
      if (state == 'email') submitEmail();
      else if (state == 'phone') submitPhone();
    }
  });
  
  } catch (error) {
    console.error('Marketing modal failed to initialize:', error);
    // Ensure showMeerkat is defined even if initialization fails
    window.showMeerkat = function() {
      alert('Special offer: Use code HSKHJM for $50 off if you order a full roll!');
    };
    window.hideAllMeerkat = function() {
      console.log('Marketing modal not available');
    };
  }
})();
